import { Component, type ReactNode } from 'react';

export type ErrorBoundaryProps = {
    fallback: (info: { error: Error }) => ReactNode;
    log: (error: Error, info: { componentStack?: string | null }) => void;
    children: ReactNode;
};

type State = { error: Error | null };

export class ErrorBoundary extends Component<ErrorBoundaryProps, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error, info: { componentStack?: string | null }): void {
        this.props.log(error, info);
    }

    render(): ReactNode {
        if (this.state.error) {
            return this.props.fallback({ error: this.state.error });
        }
        return this.props.children;
    }
}
